import { LinkNode } from '@lexical/link';

import { sanitizeUrl } from '../../utils';

const isPatched = Symbol('safeLinkSanitizerPatched');

/**
 * Применяет безопасную реализацию `sanitizeUrl` к `LinkNode.prototype`.
 *
 * В Lexical 0.43.0 механизм `nodes: [SubClass, { replace: BaseClass }]`
 * неработоспособен для same-type подклассов: `withKlass` уходит в бесконечный
 * цикл в `resolveRegisteredNodeAfterReplacements`, а `with` без `withKlass`
 * логирует deprecation-warning на каждый инстанс редактора. Поэтому патчим
 * прототип напрямую — это разовая идемпотентная операция, покрывающая все
 * `LinkNode` и `AutoLinkNode` (наследуется) инстансы независимо от того, как
 * они созданы (`$createLinkNode`, `importJSON`, вставка `<a>`).
 */
export const installSafeLinkSanitizer = (): void => {
  const proto = LinkNode.prototype as LinkNode & { [isPatched]?: boolean };
  if (proto[isPatched]) return;
  proto.sanitizeUrl = sanitizeUrl;
  proto[isPatched] = true;
};

installSafeLinkSanitizer();
